"use strict";

require("core-js/modules/es6.array.filter");

require("core-js/modules/es6.array.map");

require("core-js/modules/es6.object.define-property");

require("core-js/modules/es6.symbol");

require("core-js/modules/es6.array.index-of");

require("core-js/modules/es6.object.assign");

var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
    }

    return t;
  };

  return __assign.apply(this, arguments);
};

var __rest = this && this.__rest || function (s, e) {
  var t = {};

  for (var p in s) {
    if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  }

  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};

var __importStar = this && this.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) {
    if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
  }
  result["default"] = mod;
  return result;
};

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var utils_1 = require("@lsg/utils");

var React = __importStar(require("react"));

var react_animate_height_1 = __importDefault(require("react-animate-height"));

var CSSPrefix_1 = require("../../../base/CSSPrefix");

var IndicatorLinks_1 = require("../../atoms/_IndicatorLinks/IndicatorLinks");

var SideNavigationItemsInner = function SideNavigationItemsInner(_a) {
  var id = _a.id,
      className = _a.className,
      items = _a.items,
      props = __rest(_a, ["id", "className", "items"]); // this should be kept returning an Array and should not be refactored into a real JSX component as it will break IndicatorLinks <-> IndicatorLinks.Link relationship
  // recursively build our component tree from navigationObject


  return items && items.map(function (item) {
    var activeItem = props.activeItem,
        onChange = props.onChange,
        indicatorAtLevel = props.indicatorAtLevel;

    var children = item.children,
        targetValue = item.targetValue,
        expanded = item.expanded,
        level = item.level,
        nonCollapsible = item.nonCollapsible,
        otherProps = __rest(item, ["children", "targetValue", "expanded", "level", "nonCollapsible"]); // extract children and indicator from item props


    var activeItemArr = children && children.filter(function (child) {
      return child.targetValue === activeItem;
    });

    var _path = otherProps._path,
        _item = otherProps._item,
        _expanded = otherProps._expanded,
        _indicator = otherProps._indicator,
        cleanUpProps = __rest(otherProps, ["_path", "_item", "_expanded", "_indicator"]);

    return children ? React.createElement(IndicatorLinks_1.IndicatorLinks.Link, __assign({}, cleanUpProps, {
      className: utils_1.DomUtils.cleanupClassNames([otherProps.className, expanded && CSSPrefix_1.lsgPre + "sidenavigation-indicatorlinks-link__expanded", CSSPrefix_1.lsgPre + "sidenavigation-level-" + level]),
      notClickable: nonCollapsible,
      onClick: function onClick(ev) {
        return onChange(targetValue, ev);
      }
    }), React.createElement(react_animate_height_1["default"], {
      duration: 300,
      height: expanded ? "auto" : 0
    }, React.createElement(IndicatorLinks_1.IndicatorLinks // if a child items' id is activeId, set activeId to childs' id on IndicatorLinks container
    , {
      // if a child items' id is activeId, set activeId to childs' id on IndicatorLinks container
      activeId: activeItemArr.length ? activeItemArr[0].id : undefined,
      indicator: item.level === indicatorAtLevel - 1
    }, SideNavigationItemsInner(__assign({
      items: children
    }, props))))) : // if item has no children, render IndicatorLinks.Link with onClick setState activeId
    React.createElement(IndicatorLinks_1.IndicatorLinks.Link, __assign({}, cleanUpProps, {
      className: utils_1.DomUtils.cleanupClassNames([otherProps.className, CSSPrefix_1.lsgPre + "sidenavigation-level-" + level]),
      onClick: function onClick(ev) {
        return onChange(targetValue, ev);
      }
    }));
  });
};

var SideNavigationItems = function SideNavigationItems(_a) {
  var className = _a.className,
      props = __rest(_a, ["className"]);

  var activeId;

  if (props.items) {
    var activeItemArr = props.items.filter(function (child) {
      return child.targetValue === props.activeItem;
    });

    if (activeItemArr.length > 0) {
      activeId = activeItemArr[0].id;
    }
  }

  return React.createElement(IndicatorLinks_1.IndicatorLinks // if a child items' id is activeId, set activeId to childs' id on IndicatorLinks container
  , {
    // if a child items' id is activeId, set activeId to childs' id on IndicatorLinks container
    activeId: activeId,
    indicator: props.indicatorAtLevel === 1 || undefined,
    className: className
  }, SideNavigationItemsInner(props) || React.createElement(React.Fragment, null));
};

exports.SideNavigationItems = SideNavigationItems;
SideNavigationItems.displayName = "SideNavigationItems";